import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { LabContext, LabName } from '../context/lab';

const ChangeCluster = () => {
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const navigate = useNavigate();

    const { search, pathname, hash } = useLocation();
    const labParam = new URLSearchParams(search).get('lab');
    const labs = Object.keys(LabName).filter((v) => isNaN(Number(v)));

    const {lab, changeLab} = React.useContext(LabContext);

    React.useEffect(() => {
        if (!labParam && lab ) {
            navigate({ 
                hash: hash,
                pathname: pathname,
                search: createSearchParams({ lab: `${LabName[lab.name]}` }).toString() 
            },{
                replace: true
            });
            navigate(0);
        } 
        // else 
        // if (!lab|| labParam !== LabName[lab.name]){
        //     changeLab(labParam as unknown as LabName);
        // }
    }, [labParam, hash, pathname, lab, navigate]);

    const changeLabClicked: (labName: LabName) => void = (labName: LabName) => {
        navigate({ 
            hash: hash,
            pathname: pathname,
            search: createSearchParams({ lab: `${labName}` }).toString() 
        },{
            replace: true
        });
        navigate(0);
        changeLab(labName);
        handleCloseUserMenu();
        
    }

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const clusterBtnText: string = lab && LabName[lab?.name]? LabName[lab?.name] : labs[0];

  return (
    <Box sx={{ flexGrow: 0 }}>
        <Tooltip title="Choose Cluster">
            <Button variant="contained" color="success"  onClick={handleOpenUserMenu} sx={{ pr: 1, pl: 1 }}>{clusterBtnText}</Button>
        </Tooltip>
        <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
        >
            {labs.map((labName: string,) => (
            <MenuItem key={labName} onClick={() => changeLabClicked(labName as unknown as LabName)}>
                <Typography textAlign="center">{labName.toUpperCase()}</Typography>
            </MenuItem>
            ))}
        </Menu>
    </Box>
  );
}

export default ChangeCluster